// extracted by mini-css-extract-plugin
export var addToCartButton = "_nq-b";
export var arrowButtonContainer = "_nq-9";
export var arrowButtonIcon = "_nq-a";
export var carouselArrowButton = "_nq-6";
export var carouselElementContainer = "_nq-1";
export var left = "_nq-7";
export var productDisplayCarouselContainer = "_nq-0";
export var productTileContainer = "_nq-2";
export var productTileImage = "_nq-4";
export var productTileImageContainer = "_nq-3";
export var productTileTitle = "_nq-5";
export var right = "_nq-8";
export var sliderOverflow = "_nq-c";